/* eslint-disable react/prop-types */
import { farmReportApi } from 'api/endpoints/farm';
import React, { useEffect, useState } from 'react';
import MapModel from 'screens/common/dynamicForm/dynamicNormalForm/FormFields/Mapmodel';
function ViewComponent({ farmerId, rowData, onClose }) {
  const [mapData, setMapData] = useState(null); // State for map data
  const [data, setData] = useState(null); // State for map data
  const tns_tenant = '03534add672340809e2c70314b1ce20e';

  const fetchFormData = async () => {
    // If coordinates are directly available in rowData, use them
    if (rowData?.coordinates) {
      let coords = rowData.coordinates;

      // Handle stringified JSON
      if (typeof coords === 'string') {
        try {
          coords = JSON.parse(coords);
        } catch (e) {
          console.error('Failed to parse coordinates string:', e);
          coords = null;
        }
      }

      let geoJson = null;

      // If it's already a GeoJSON object, use it directly
      if (coords && typeof coords === 'object' && coords.type) {
        geoJson = coords;

        // Ensure all polygons in the FeatureCollection are closed for robust rendering
        if (
          geoJson.type === 'FeatureCollection' &&
          Array.isArray(geoJson.features)
        ) {
          geoJson.features.forEach(feature => {
            if (
              feature.geometry?.type === 'Polygon' &&
              Array.isArray(feature.geometry.coordinates)
            ) {
              feature.geometry.coordinates.forEach(ring => {
                if (Array.isArray(ring) && ring.length > 0) {
                  const first = ring[0];
                  const last = ring[ring.length - 1];
                  if (first[0] !== last[0] || first[1] !== last[1]) {
                    ring.push(first);
                  }
                }
              });
            }
          });
        }
      } else if (Array.isArray(coords) && coords.length > 0) {
        // Handle array of {lat, lng} - Convert to GeoJSON Polygon
        // MapModel usually expects Polygon coordinates as array of arrays of [lng, lat]
        const polygonCoords = coords.map(c => [c.lng, c.lat]);
        // Close the polygon if it's not closed
        if (
          polygonCoords.length > 0 &&
          (polygonCoords[0][0] !== polygonCoords[polygonCoords.length - 1][0] ||
            polygonCoords[0][1] !== polygonCoords[polygonCoords.length - 1][1])
        ) {
          polygonCoords.push(polygonCoords[0]);
        }

        geoJson = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'Polygon',
                coordinates: [polygonCoords]
              }
            }
          ]
        };
      }

      if (geoJson) {
        setData({
          fields: [
            {
              type: 'coordinates',
              defaultValue: geoJson
            }
          ]
        });
        return; // Add this return to prevent subsequent API calls
      }
    }

    let id = farmerId;
    let isEdit = true;
    try {
      const formResponse = await farmReportApi.getDynamicFarmForm(isEdit, id);
      const formSchema = formResponse.data.results;

      const editResponse = await farmReportApi.getDynamicFarmForm(isEdit, id);

      if (editResponse?.data?.results) {
        const updatedFields = formSchema.fields.map(field => {
          if (field.table) {
            // Handle table field, replace rows with the data from the edit response
            const tableData = editResponse.data.results[field.id] || [];
            return {
              ...field,
              table: {
                ...field.table,
                rows: tableData.length > 0 ? tableData : field.table.rows // Replace with editResponse rows if available
              }
            };
          } else {
            return {
              ...field,
              defaultValue:
                editResponse.data.results[field.id] || field.defaultValue
            };
          }
        });

        formSchema.fields = updatedFields;
        setData(formSchema);

        // Assuming you need to pass geoJSON data to the MapModel
        const geoJsonData = editResponse.data.geoJson || {}; // Replace with actual field
        setMapData(geoJsonData);
      }
    } catch (error) {
      console.error('Error fetching form data:', error);
    }
  };

  useEffect(() => {
    if (farmerId || rowData) {
      fetchFormData(); // Fetch data when farmerId or rowData is passed
    }
  }, [farmerId, rowData]);

  return (
    <div>
      {data?.fields.map((item, index) => (
        <div key={index}>
          {item.type === 'coordinates' && (
            <MapModel
              key={farmerId}
              showModal={true}
              setShowModal={onClose} // Close modal when needed
              mode="polygon"
              uploadedGeoJSONLayer={item.defaultValue} // Pass the geoJSON data to the map model
              onLocationSelect={() => {}}
              isMapEditable={false}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default ViewComponent;
